import PropTypes from "prop-types";
import { memo } from "react";
import { ClipLoader } from "react-spinners";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Link from "next/link";

const ServicesList = memo(({ services, loading, className = "" }) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const lang = router.locale || "en";

  return (
    <section
      className={`w-full box-border bg-[#f3f3f3] text-black px-[24px] md:px-[60px] lg:px-[74px] py-[40px] md:py-[50px] lg:py-[56px] ${className}`}
    >
      <div className="w-full box-border max-w-[1600px] mx-auto">
        {/* <h1 className="text-[28px] sm:text-[34px] lg:text-[42px] font-medium leading-[1.1] tracking-[-0.02em] mb-[28px] md:mb-[36px] mt-0">
          {t("services.list.title", "Our Digital Marketing Expertise")}
        </h1> */}

        {loading ? (
          <div className="w-full flex justify-center items-center py-20">
            <ClipLoader color="#ff4f6d" size={48} />
          </div>
        ) : (
          <div className="flex flex-col">
            {services?.map((service, index) => {
              const number = String(index + 1).padStart(2, "0");

              return (
                <div
                  key={service?.slug || service?.id || index}
                  className={`py-[22px] md:py-[26px] ${
                    index !== services.length - 1
                      ? "border-b border-solid border-black/10"
                      : ""
                  }`}
                >
                  <div className="flex flex-col gap-[18px] md:gap-[22px]">
                    <div className="flex items-center gap-3">
                      <span className="text-[#ff4f6d] text-[22px] md:text-[26px] font-normal leading-none min-w-[38px]">
                        {number}
                      </span>

                      <h2 className="text-[22px] md:text-[28px] lg:text-[32px] font-medium leading-[1.15] tracking-[-0.02em] m-0">
                        {service?.title}
                      </h2>
                    </div>

                    <div className="pl-0 md:pl-[40px]">
                      <div className="flex flex-wrap gap-x-5 gap-y-5">
                        {service?.services?.map((child, pillIndex) => {
                          return (
                            <Link
                              key={`${child?.slug}-${pillIndex}`}
                              href={`/${child?.fullSlug_en}`}
                              className={`h-[40px] md:h-[42px] px-[16px] md:px-[18px] rounded-full border border-solid flex items-center justify-center text-[14px] md:text-[15px] font-normal leading-none whitespace-nowrap transition-all duration-300 no-underline ${
                                // active
                                // ? "border-[#ff4f6d] text-black bg-transparent" :
                                "border-black/10 text-black/90 bg-transparent"
                              }`}
                            >
                              {child?.menuname}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
});

ServicesList.propTypes = {
  className: PropTypes.string,
  services: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      slug: PropTypes.string,
      title: PropTypes.string,
      menuname: PropTypes.string,
      menuname_ar: PropTypes.string,
    }),
  ).isRequired,
  loading: PropTypes.bool,
};

export default ServicesList;
